let instances = document.querySelectorAll('.texty'),
  interval = 100,
  timeout = null;

const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (entry.intersectionRatio < 0.1) return;

    let e = entry.target;

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      let wrapped = e.textContent.replace(/(\S+)/g, '<span class="texty-cell">$1</span>'),
        original = e.innerHTML,
        current = 0;

      e.innerHTML = wrapped;

      e.classList.add('texty--init');

      e.querySelectorAll('.texty-cell').forEach(cell => {
        current += interval;

        setTimeout(() => {
          cell.classList.add('texty-cell--enable');
        }, current);
      })

      // remove large markup
      setTimeout(() => {
        e.innerHTML = original;
      }, current + 1000);


    }, 150)

    observer.unobserve(e);
  });
}, {threshold: 0.1});


instances.forEach(el => observer.observe(el));
